import React from 'react';
import { Platform } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { FontAwesome } from '@expo/vector-icons';

import tw from '../styles/tailwind';

import DashboardScreen from '../screens/MetaAdmin/Dashboard/DashboardScreen';
import UsersListScreen from '../screens/MetaAdmin/Users/UsersListScreen';
import UserDetailScreen from '../screens/MetaAdmin/Users/UserDetailScreen';
import CommunitiesListScreen from '../screens/MetaAdmin/Communities/CommunitiesListScreen';
import CommunityDetailScreen from '../screens/MetaAdmin/Communities/CommunityDetailScreen';
import DevicesScreen from '../screens/MetaAdmin/Devices/DevicesScreen';
import IconShowcaseScreen from '../screens/MetaAdmin/Dev/IconShowcaseScreen';

const Stack = createNativeStackNavigator();
const BottomTab = createBottomTabNavigator();

export default function MetaAdminStackNavigator() {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="MetaAdmin.Home"
        component={MetaAdminBottomTabNavigator}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="MetaAdmin.Users.Detail"
        component={UserDetailScreen}
        options={{ title: 'Usuario' }}
      />

      <Stack.Screen
        name="MetaAdmin.Communities.Detail"
        component={CommunityDetailScreen}
        options={{ title: 'Fraccionamiento' }}
      />
    </Stack.Navigator>
  );
}

function TabIcon({ name, color }: { name: any; color: string }) {
  return <FontAwesome size={20} name={name} color={color} style={{ marginBottom: -3 }} />;
}

function MetaAdminBottomTabNavigator() {
  const insets = useSafeAreaInsets();

  return (
    <BottomTab.Navigator
      initialRouteName="MetaAdmin.Dashboard"
      screenOptions={{
        tabBarActiveTintColor: tw.color('secondary'),
        tabBarStyle: {
          height: 57 + insets.bottom,
          paddingBottom: 7 + insets.bottom,
        },
        headerShown: false,
      }}
    >
      <BottomTab.Screen
        name="MetaAdmin.Dashboard"
        component={DashboardScreen}
        options={{
          title: 'Resumen',
          tabBarIcon: ({ color }) => <TabIcon name="dashboard" color={color} />,
        }}
      />
      <BottomTab.Screen
        name="MetaAdmin.Users.Index"
        component={UsersListScreen}
        options={{
          title: 'Usuarios',
          tabBarIcon: ({ color }) => <TabIcon name="users" color={color} />,
        }}
      />
      <BottomTab.Screen
        name="MetaAdmin.Communities.Index"
        component={CommunitiesListScreen}
        options={{
          title: 'Fraccionamientos',
          tabBarIcon: ({ color }) => <TabIcon name="building" color={color} />,
        }}
      />
      <BottomTab.Screen
        name="MetaAdmin.Devices.Index"
        component={DevicesScreen}
        options={{
          title: 'Dispositivos',
          tabBarIcon: ({ color }) => <TabIcon name="hdd-o" color={color} />,
        }}
      />
      <BottomTab.Screen
        name="MetaAdmin.Dev.IconShowcase"
        component={IconShowcaseScreen}
        options={{
          title: 'Iconos',
          tabBarIcon: ({ color }) => <TabIcon name="image" color={color} />,
        }}
      />
    </BottomTab.Navigator>
  );
}
